import { connect } from 'react-redux';
import Events from './Events';
import I18n from '../../lib/i18n';
import { isLoadingSelector } from '../../modules/LoadingStatus/reducer';
import { fetchNotifications, notificationsSelector } from '../../modules/Notification';

const mapStateToProps = state => ({
  events: notificationsSelector(state),
  isRefreshing: isLoadingSelector(state, 'fetchNotifications'),
  emptyText: I18n.t('Dashboard.Notifications.emptyText'),
});

const mapDispatchToProps = {
  fetchEvents: fetchNotifications,
};

export default connect(mapStateToProps, mapDispatchToProps)(Events);
